import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=1dc87b94&"
import script from "./RegisterUser.vue?vue&type=script&lang=js&"
export * from "./RegisterUser.vue?vue&type=script&lang=js&"
import style0 from "./RegisterUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports